import script from "./main03Swiper.vue?vue&type=script&setup=true&name=main03Swiper&lang=js"
export * from "./main03Swiper.vue?vue&type=script&setup=true&name=main03Swiper&lang=js"

const __exports__ = script;

export default __exports__